import { useState } from "react";

import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";

import { Title } from "components/customElements";
import FontAwesomeIcon from "components/FontAwesomeIcon";

export const DESCRIPTIONS = [
  {
    name: "SK Actionability Score",
    descriptions: "Measure of statistical mean-reversion",
  },
  {
    name: "SK Investability Score",
    descriptions: "Measure of ease of implementation",
  },
];

const Descriptions = () => {
  const [expand, setExpand] = useState(false);
  return (
    <>
      <Title className="flex !text-[inherit] !text-sm !font-bold !normal-case	!tracking-normal">
        <div
          className="flex-1 cursor-pointer"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          Key Metrics and Definitions
        </div>
        <div
          className="items-end text-right text-[15px] cursor-pointer"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          <FontAwesomeIcon icon={expand ? faChevronUp : faChevronDown} />
        </div>
      </Title>
      {expand &&
        DESCRIPTIONS.map((item) => {
          return (
            <p className="mb-0 text-sm" key={item.name}>
              <b>{item.name} : </b>
              {item.descriptions}
            </p>
          );
        })}
    </>
  );
};

export default Descriptions;
